import React, { Component } from 'react';
import { withOktaAuth } from '@okta/okta-react';

class Initiate extends Component {
  componentDidMount() {
    this.props.authService.login('/');
  }

  render() {
    return(
      <div>Initiating SSO</div>
    )
  }
}

export default withOktaAuth(Initiate)